import Label from "components/Label/Label";
import React, { FC, Fragment, useState, useEffect, useRef } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Input from "shared/Input/Input";
import CommonLayout from "./CommonLayout";
import { Helmet } from "react-helmet";
import axios from "axios";
import SectionPromoCodeSlider from "components/SectionPromoCodeSlider/SectionPromoCodeSlider";
import ButtonCircle from "shared/Button/ButtonCircle";
import { Dialog, Transition } from "@headlessui/react";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import { FaFacebookF, FaTwitter } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { FiCopy } from "react-icons/fi";
import { FacebookShareButton, TwitterShareButton, WhatsappShareButton, PinterestShareButton, LinkedinShareButton, EmailShareButton, FacebookMessengerShareButton } from "react-share";
import { useAuth } from "hooks/useAuth"; // Adjust path if needed
export interface PagePromoCodeProps {
  className?: string;
}
const PagePromoCode: FC<PagePromoCodeProps> = ({ className = "" }) => {
  const { user } = useAuth();
  const [promoCode, setPromoCode] = useState("");
  const [error, setError] = useState("");
  const [resultMessage, setResultMessage] = useState("");
  const [activeTab, setActiveTab] = useState<"available" | "notAvailable">("available");
  const [availableCoupons, setAvailableCoupons] = useState([]);
  const [notAvailableCoupons, setNotAvailableCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isOpenModalInviteFriends, setIsOpenModalInviteFriends] = useState(false);
  const FacebookIcon = FaFacebookF as unknown as React.FC;
  const TwitterIcon = FaTwitter as unknown as React.FC;
  const EmailIcon = HiOutlineMail as unknown as React.FC;
  const CopyIcon = FiCopy as unknown as React.FC;

  const IconWrapper = (IconComponent: React.FC<any>, bgColor: string) => (
    <div className={`p-3 rounded-full`} style={{ backgroundColor: bgColor }}>
      <IconComponent size={30} color="white" />
    </div>
  );
  // ✅ Fetch promo codes from API
  const fetchPromoCodes = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}getUserPromoCodes`, {
        params: { user_id: user?.user_id }
      });

      if (response.data.success) {
        setAvailableCoupons(response.data.available_coupons || []);
        setNotAvailableCoupons(response.data.not_available_coupons || []);
      } else {
        setAvailableCoupons([]);
        setNotAvailableCoupons([]);
      }
    } catch (error) {
      console.error("Error fetching promo codes:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchPromoCodes();
  }, []);

  // ✅ Handle input change
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPromoCode(e.target.value);
    setError(""); // Clear error on change
  };

  // ✅ Apply promo code & refresh slider
  const handleApplyCode = async () => {
    if (!promoCode.trim()) {
      setError("Please enter a promo code.");
      return;
    }
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}redeemPromocode`,
        { promoCode, user_id: user?.user_id }
      );

      if (response.data.success) {
        setResultMessage("Promo code applied successfully!");
        setPromoCode(""); // Clear input
        fetchPromoCodes(); // ✅ Refresh slider
      } else {
        setResultMessage(response.data.message || "Invalid promo code.");
      }
    } catch (error) {
      setResultMessage("Promo code is invalid.");
    }
  };

const shareUrl = "https://example.com/listing/123";
const shareTitle = "Check out this amazing listing!";
const shareSummary = "One of the best places to stay. Book now!";
const shareEmailBody = `${shareTitle}\n\n${shareSummary}\n\n${shareUrl}`;

const shareOptions = [
  {
    label: 'Facebook',
    icon: FacebookIcon,
    bgColor: '#1877F2',
    button: FacebookShareButton,
    props: { url: shareUrl, quote: shareTitle },
  },
  {
    label: 'Twitter',
    icon: TwitterIcon,
    bgColor: '#1DA1F2',
    button: TwitterShareButton,
    props: { url: shareUrl, title: shareTitle },
  },
  {
    label: 'Email',
    icon: EmailIcon,
    bgColor: '#7B7B7B',
    button: EmailShareButton,
    props: { url: shareUrl, subject: 'Sharing a listing with you', body: shareTitle },
  },
];

  const handleShareClick = (platform:any) => {
    const url = window.location.href;
    switch (platform) {
      case 'Facebook':
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`);
        break;
      case 'Twitter':
        window.open(`https://twitter.com/intent/tweet?url=${url}`);
        break;
      case 'Email':
        window.location.href = `mailto:?subject=Check this out&body=${url}`;
        break;
      case 'Copy':
        navigator.clipboard.writeText(url);
        alert('Link copied to clipboard!');
        break;
    }
  }; 
  const renderMotalInviteFriends = () => {
    return (
      <Transition appear show={isOpenModalInviteFriends} as={Fragment}>
      <Dialog as="div" className="fixed inset-0 z-50 overflow-y-auto model-sm-min" onClose={closeModalInviteFriends}>
        <div className="min-h-screen px-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-40" />
          </Transition.Child>

          <span className="inline-block h-screen align-middle" aria-hidden="true">&#8203;</span>

          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="inline-block py-8 h-screen w-full sm:w-xl Coupons-model">
              <div className="inline-flex flex-col w-1/2 max-w-xl text-left align-middle transition-all transform overflow-hidden rounded-2xl bg-white dark:bg-neutral-900 dark:border dark:border-neutral-700 dark:text-neutral-100 shadow-xl h-1/2">
                <div className="relative flex-shrink-0 px-6 py-4 border-b border-neutral-200 dark:border-neutral-800 text-center">
                  <h3 className="text-lg font-medium leading-6 text-gray-900">
                    SHARE VIA
                  </h3>
                  <span className="absolute right-3 top-3">
                    <ButtonClose onClick={closeModalInviteFriends} />
                  </span>
                </div>
                
                <div className="px-8 text-neutral-700 dark:text-neutral-300 divide-y divide-neutral-200">
                  <div className="container mt-5">
                  <div className="grid grid-cols-4 gap-4">
                      {shareOptions.map((option, idx) => {
                        const ShareButton = option.button;
                        return (
                          <ShareButton {...option.props} key={idx} className="flex flex-col items-center gap-2 text-center">
                            {IconWrapper(option.icon, option.bgColor)}
                            <span className="font-medium text-sm">{option.label}</span>
                          </ShareButton>
                        );
                      })}
                      <div onClick={() => { navigator.clipboard.writeText(shareUrl); }} className="flex flex-col items-center gap-2 text-center cursor-pointer">
                        {IconWrapper(CopyIcon, '#9CA3AF')}
                        <span className="font-medium text-sm">Copy</span>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
    );
  };
  function closeModalInviteFriends() {
    setIsOpenModalInviteFriends(false);
  }
  function openModalInviteFriends() {
    setIsOpenModalInviteFriends(true);
  }
  return (
    <div className="bgcolor-light pb-14 pt-10">
      <Helmet title={'Tiny Away Available Promo Code'}></Helmet>
      <div className="container">
        <div className="row-profile mt-5 mb-5">
          <CommonLayout />
          {/* Promo Code Section */}
          <div className="right-user-details-card">
            <div className="card">
              <div className="flex justify-between">
                <h4>Promo Code</h4>
              </div>

              {/* ✅ Promo Code Input */}
              <div className="mt-7 relative max-w-sm">
                <Input
                  type="text"
                  placeholder="Enter promo code and redeem"
                  value={promoCode}
                  onChange={handleInputChange}
                />
                <ButtonCircle
                  onClick={handleApplyCode}
                  className="absolute transform top-1/2 -translate-y-1/2 right-1"
                >
                  <i className="las la-arrow-right text-xl"></i>
                </ButtonCircle>

              </div>
              {error && <p className="text-red-500 mt-2">{error}</p>}
              {resultMessage && <p className="text-green-500 mt-2">{resultMessage}</p>}

              {/* ✅ Tabs for Available & Not Available */}
              <div className="list-tab-account mt-5">
                <a
                  href="javascript:void(0);"
                  className={`tab ${activeTab === "available" ? "active" : ""}`}
                  onClick={() => setActiveTab("available")}
                >
                  Available
                </a>
                <a
                  href="javascript:void(0);"
                  className={`tab border-l ${activeTab === "notAvailable" ? "active" : ""}`}
                  onClick={() => setActiveTab("notAvailable")}
                >
                  Not Available
                </a>
              </div>

              <div className="line-mid mt-5 mb-5"></div>

              {/* ✅ Promo Code Slider - Dynamically Load Based on Active Tab */}
              {loading ? (
                <p>Loading...</p> // ✅ Show loading state while fetching
              ) : activeTab === "available" ? (
                <SectionPromoCodeSlider categories={availableCoupons} itemPerRow={2} />
              ) : (
                <SectionPromoCodeSlider categories={notAvailableCoupons} itemPerRow={2} />
              )}

              {/* Fallback Content */}
              <div className="mb-10 mid-box-refl mt-100 text-center w-1/2 m-lr">
                <h5>FRESH OUT OF PROMO CODES</h5>
                <p>Got a promo code? Enter it above. Or you can invite friends to TinyAway and earn rewards.</p>
                <div className="text-center mt-5">
                  <a href="#" className="btn btn-box-css big-btn" onClick={openModalInviteFriends}>INVITE FRIENDS</a>
                  <a href="#" className="btn btn-black big-btn m-8">START EXPLORING</a>
                </div>
                {renderMotalInviteFriends()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PagePromoCode;
